import {UpdateInfoActions, UpdateInfoActionTypes} from '../actions/update-info.actions';

export interface UpdateInfoState {
  isLoaded: boolean;
  isSaved: boolean;
  isLoading: boolean;
  type: string;
  msg: any;
}

export const initialState: UpdateInfoState = {
  isLoaded: false,
  isSaved: false,
  isLoading: false,
  type: '',
  msg: ''
};

export function reducer(state = initialState, action: UpdateInfoActions): UpdateInfoState {
  switch (action.type) {
    case UpdateInfoActionTypes.UPDATE_INFO:
      return {...state, isLoaded: false, isSaved: false, isLoading: true, type: action.payload.type, msg: ''};
    case UpdateInfoActionTypes.UPDATE_INFO_SUCCESS:
      return {...state, isLoaded: true, isSaved: true, isLoading: false, type: action.payload.type, msg: action.payload.msg};
    case UpdateInfoActionTypes.UPDATE_INFO_FAIL:
      return {...state, isLoaded: true, isSaved: false, isLoading: false, type: action.payload.type, msg: action.payload.errmsg};
    default:
      return state;
  }
}

